(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["langley-edit-landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = () => {
      const popup = document.getElementById('langley-edit-popup');
      if (!popup || typeof popup.showModal !== 'function') return;
      if (popup.dataset.langleyInitialized === 'true') return;
      popup.dataset.langleyInitialized = 'true';
      const key = 'langley-summers-last-edit-popup-seen';
      try { if (sessionStorage.getItem(key) === '1') return; } catch (e) {}
      const show = () => {
        if (!popup.isConnected || popup.open || document.visibilityState !== 'visible') return;
        try { sessionStorage.setItem(key, '1'); } catch (e) {}
        popup.showModal();
      };
      const handle = setTimeout(show, 6500);
      const dismiss = () => { clearTimeout(handle); if (popup.open) popup.close(); };
      popup.querySelector('[data-langley-popup-close]')?.addEventListener('click', dismiss);
      popup.querySelector('[data-langley-popup-shop]')?.addEventListener('click', () => {
        dismiss();
        document.getElementById('ResultsList')?.scrollIntoView({behavior:'smooth',block:'start'});
      });
      popup.addEventListener('click', (event) => { if (event.target === popup) dismiss(); });
      popup.addEventListener('close', () => { clearTimeout(handle); });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
    else initialize();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
